export default "__VITE_ASSET__Cd1JgteH__"